import { Flex, FlexProps, Image, useDisclosure } from "@chakra-ui/react";
import { lazy, Suspense, useState } from "react";

interface Props extends FlexProps {
  currentImage: number;
  images: string[] | undefined;
}

const ImagePreviewModal = lazy(() => import("../modal/ImagePreviewModal"));

export const PrimaryImage = ({ currentImage, images, ...rest }: Props) => {
  const [selectedImage, setSelectedImage] = useState<string>("");
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleClick = (image: string) => {
    setSelectedImage(image);

    onOpen();
  };

  return (
    <>
      <Flex
        transition="transform 0.5s ease-in-out"
        w={"full"}
        h={"auto"}
        transform={`translateX(-${currentImage * 100}%)`}
        {...rest}
      >
        {images &&
          (images as string[]).map((image: string, index: number) => (
            <Image
              key={index}
              flex={"none"}
              src={image ? `${process.env.REACT_APP_MEDIA_URL}${image}` : ""}
              alt={`Slide ${index + 1}`}
              objectFit="cover"
              objectPosition="center"
              w="full"
              aspectRatio={10 / 7}
              rounded="8px"
              onClick={() => handleClick(image)}
              cursor={"pointer"}
            />
          ))}
      </Flex>

      <Suspense>
        <ImagePreviewModal
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          data={selectedImage}
          children={undefined}
        />
      </Suspense>
    </>
  );
};
